const PersonalLogo = (props) => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M37.6588 16.6694L8.92449 9.35579C7.65344 9.03228 6.36079 9.80041 6.03727 11.0715L1.4197 29.2134C1.09619 30.4844 1.86432 31.7771 3.13537 32.1006L31.8697 39.4142C33.1407 39.7377 34.4334 38.9696 34.7569 37.6985L39.3745 19.5566C39.698 18.2856 38.9299 16.9929 37.6588 16.6694Z"
      fill="url(#paint0_radial)"
    />
    <path
      d="M38.5994 22.6595L5.22363 14.1646L4.29473 17.8141L37.6705 26.3091L38.5994 22.6595Z"
      fill="white"
    />
    <path
      d="M35.2922 5.11733C34.8649 3.9945 33.5036 3.27908 32.3013 3.51755C31.8045 3.61692 31.3474 3.80571 30.9002 4.03425C30.0258 4.49133 29.211 5.0279 28.6049 5.81288C28.118 6.44881 27.6311 7.09469 27.1244 7.71075C26.7468 8.16783 26.3394 8.59509 25.9519 9.0323C25.932 9.0323 25.9121 9.02236 25.9022 9.01243C25.8923 8.8137 25.8624 8.61497 25.8624 8.41624C25.8426 7.52196 25.8326 6.61773 25.8227 5.72345C25.8227 5.18688 25.8525 4.65031 25.7929 4.12368C25.7035 3.28901 25.3855 2.51397 25.0079 1.77867C24.7297 1.2421 24.3918 0.735338 23.8255 0.427307C23.1796 0.0795298 22.484 -0.129136 21.7786 0.0894662C20.7352 0.41737 19.9105 1.03343 19.682 2.16619C19.3739 3.71628 19.682 5.14714 20.5365 6.46869C20.9638 7.1245 21.5997 7.50208 22.3648 7.70081C22.7623 7.81011 23.1597 7.79024 23.5572 7.671C23.6963 7.63126 23.736 7.671 23.7559 7.80018C23.8652 8.4063 23.9845 9.01243 24.1037 9.61855C24.1236 9.71792 24.1037 9.7676 24.0143 9.82722C23.5274 10.1551 23.0306 10.4731 22.5635 10.8308C21.1724 11.894 19.9204 13.0963 18.7082 14.3384C17.804 15.2625 16.8699 16.1667 16.0949 17.21C15.5981 17.8758 15.1708 18.5713 14.9423 19.3762C14.8131 19.8432 14.7733 20.3201 14.8926 20.8269C18.1617 18.0546 21.401 15.3022 24.6701 12.5299C24.68 12.5796 24.6899 12.6094 24.6999 12.6293C24.7396 12.8181 24.7595 13.146 24.7893 13.4143L27.7901 14.2092C27.7206 13.8217 27.6411 13.4342 27.6013 13.2056C27.4423 12.3908 27.2237 11.586 26.9356 10.8109C26.8958 10.6917 26.9157 10.6321 27.0051 10.5526C27.3629 10.2644 27.7007 9.95639 28.0584 9.66823C28.2273 9.52912 28.3963 9.39001 28.5254 9.28071C28.7937 9.51919 29.0222 9.78747 29.3005 9.94646C30.1351 10.4234 31.0294 10.493 31.9436 10.1551C33.1459 9.70798 34.0998 8.96274 34.8748 7.95916C35.5505 7.07481 35.6996 6.12091 35.312 5.09745L35.2922 5.11733Z"
      fill="#3300FF"
    />
    <defs>
      <radialGradient
        id="paint0_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.24971 10.3177) scale(27.8718)"
      >
        <stop stopColor="#3B6AF5" />
        <stop offset="1" stopColor="#19AFE0" />
      </radialGradient>
    </defs>
  </svg>
)

export default PersonalLogo
